import { Alert, Card, Space, Spin, Typography } from "antd";
import { useCharacter } from "../../services/character";
import { SongLibraryPanel } from "../characters/SongLibraryPanel";

/**
 * 音乐管理的一级入口。
 *
 * 具体数据仍按角色隔离；当前角色来自后台顶栏切换器。角色详情里保留同一个面板，
 * 方便维护人设时顺手查看，但运营不需要先猜到“音乐藏在角色详情页”。
 */
export function SongsPage() {
  const { characters, characterId, loading } = useCharacter();
  const character = characters.find((item) => item.id === characterId);

  if (loading) {
    return (
      <Card>
        <Spin />
      </Card>
    );
  }

  if (!characterId || !character) {
    return (
      <Alert
        type="info"
        showIcon
        message="请先选择角色"
        description="在页面顶栏的角色切换器中选择一个角色后，即可管理她演唱的歌曲。"
      />
    );
  }

  return (
    <Space direction="vertical" size={12} style={{ width: "100%" }}>
      <div>
        <Typography.Title level={4} style={{ margin: 0 }}>
          音乐管理
        </Typography.Title>
        <Typography.Text type="secondary">
          当前角色：{character.displayName}（{character.key}）
        </Typography.Text>
      </div>
      <SongLibraryPanel characterId={characterId} />
    </Space>
  );
}
